import React from "react";
import { Card, CardContent, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  infoCard: {
    background: theme.palette.background.default,
    maxWidth: "375px",
    padding: "1.5vh 1.5vw"
  },
  progressbar: {
    backgroundColor: theme.palette.background.paper,
    margin: "1vh 0",
    "& div": {
      backgroundColor: theme.palette.primary.light,
      height: "13.5px",
      width: "48%"
    }
  }
}));

type APIUsagePageProps = {
  product: string;
  current_usage: number;
};

const APIUsagePage: React.FC<APIUsagePageProps> = ({
  product,
  current_usage
}: APIUsagePageProps) => {
  const classes = useStyles();
  return (
    <Card>
      <CardContent>
        <Typography variant="subtitle1">
          {current_usage} of 100,000 available
        </Typography>
        <div className={classes.progressbar}>
          <div style={{ width: `${current_usage / 100000}%` }}></div>
        </div>
        <Typography variant="h5">{product}</Typography>
      </CardContent>
    </Card>
  );
};

export default APIUsagePage;
